import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ReplaceProductServiceWizardEffectsV26 } from './effects';
import * as fromReplaceProductServiceWizardV26 from './reducer';

export function provideReplaceProductServiceWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromReplaceProductServiceWizardV26.replaceProductServiceWizardFeatureKey, fromReplaceProductServiceWizardV26.reducer),
    provideEffects(ReplaceProductServiceWizardEffectsV26),
  ]);
}
